import { useAppLanguageStore } from "app/stores/useAppLanguageStore";
import { countryNameFromCode } from "utils/countryNames";
import { getShelfDetail } from "utils/item";

import {
  PrivateRestockingItemFromQuery,
  PrivateRestockingList,
  TranslatedPrivateRestockingItem,
} from "./types";
import { GetPrivateRestockingListQuery } from "../../queries/privateRestockingList/privateRestockingList.generated";

function useSerializePrivateRestockingItem() {
  const appLanguage = useAppLanguageStore((state) => state.appLanguage);

  return (restockingItem: PrivateRestockingItemFromQuery): TranslatedPrivateRestockingItem => {
    const { sku, product } = restockingItem;
    const shelfDetail = product?.inventoryEntry.shelfNumber
      ? getShelfDetail(product.inventoryEntry.shelfNumber)
      : null;

    const countryOfOriginCode = product?.countryOfOrigin.code?.toUpperCase() ?? null;

    const countryOfOriginName = appLanguage
      ? countryNameFromCode(appLanguage, countryOfOriginCode)
      : null;

    return {
      sku,
      status: restockingItem.status,
      priorityTier: restockingItem.priorityTier,
      product: product
        ? {
            sku: product.sku,
            name: product.name,
            imageUrl: product.imageUrl ?? null,
            isBio: product.bio ?? null,
            shelfLetter: shelfDetail?.shelfLetter ?? null,
            shelfNumber: shelfDetail?.shelfNumber ?? null,
            shelf: product.inventoryEntry.shelfNumber ?? null,
            stockOnShelf: product.inventoryEntry.stock?.shelf ?? 0,
            numberOfShelfFacings: restockingItem.product?.numberOfShelfFacings ?? null,
            numberOfShelfStackings: restockingItem.product?.numberOfShelfStackings ?? null,
            isShelvedInHandlingUnits: !!restockingItem.product?.isShelvedInHandlingUnits,
            productClassification: product.productClassification ?? null,
            countryOfOriginCode,
            countryOfOriginName,
          }
        : null,
    };
  };
}

export function useSerializePrivateRestockingList() {
  const serializePrivateRestockingItem = useSerializePrivateRestockingItem();
  return ({
    getPrivateRestockingList: { id, restockingItems },
  }: GetPrivateRestockingListQuery): PrivateRestockingList => ({
    id,
    restockingItems: restockingItems.map(serializePrivateRestockingItem),
  });
}
